<template>
	<div>
		<RangeDropdown
			v-model="localValue"
			:options="options"
			suffix="Monate"
			@input="emitChangeEvent"
		/>
	</div>
</template>

<script>
import RangeDropdown from "@/vue/common/RangeDropdown.vue";
import _ from "lodash";

export default {

	components: {
		RangeDropdown,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		let localValue = {
			min: 1,
			max: 6
		};

		if (this.value)
		{
			localValue = this.value;
		}

		let options = _.range(1, 37, 1).map(month =>
		{
			return {
				value: month,
				text: month,
			};
		});

		return {
			localValue,
			options
		};
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', this.localValue);
		},
	}
}
</script>
